import * as angular from "angular";
import {IController, IQService, IScope, ITimeoutService} from "angular";
import * as _ from "lodash"
import {PlanningAlertsService} from "../../services/planning-alerts.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";
import {PlanningDialogService} from "../../services/planning-dialogs-service.service";
import {PlanningDraftsService} from "../../services/planning-drafts-service.service";
import {PlanningProjectsService} from "../../services/planning-projects-service.service";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {PlanningViewSettingsModel} from "../../models/planning-view-settings.model";
import {ResizeService} from "../../../commons/services/resize-service.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {BreadcrumbsService} from "../../../commons/angular/services/breadcrumbs.service";
import {DraftTemplateModel} from "../../models/default-draft-template.model";
import {
  PlanningProjectProcessTrackingRequestsService
} from "../../services/planning-project-process-tracking-requests.service";

export class PlanningProjectViewNewComponent implements IController {

  project: any;
  projectStatus: any;
  jobs: any;
  resources: any;
  depots: any;
  draftTemplate: DraftTemplateModel;
  projectTemplate: any;
  viewSettings: ViewSettingsModel;
  defaultDraftViewSettings: ViewSettingsModel;

  public selectedJobs: any[];
  public selectedJobIds: string[];
  public selectedResourceIds: any[];
  public selectedJobToView: {};
  public sortJobsSlaType: boolean | "desc" | "asc";
  public serviceAreas: any[];
  public clusteringAreas: any[] = [];
  public sortBy: any;
  public sortByType: any = 'asc';
  public isTotalOverviewActive: boolean = true;

  private projectRef: any;
  private projectsProcessTrackingRef: any;
  private serviceAreasRef: any;
  private excludeMode: boolean;
  private selectedJobSourceType: any;
  private loadingState: any;
  private selectedTab: string;
  private stops: any;
  private isRedirecting: boolean = false;
  private loadedClusteringAreaIdsKey: string;

  /* @ngInject */
  constructor(private $log, private commonsDialogService: CommonsDialogService, private $planningProjects, private $serviceArea, private commonsService: CommonsService,
              private $planningProjectsProcessTracking, private planningConstants, private planningDialogService: PlanningDialogService,
              private planningProjectProcessTrackingRequestsService: PlanningProjectProcessTrackingRequestsService,
              private planningAlertsService: PlanningAlertsService, private planningProjectsService: PlanningProjectsService, private planningDraftsService: PlanningDraftsService,
              private $state, private $filter, private $timeout: ITimeoutService, private planningCommonService: PlanningCommonService, private viewSettingsService: ViewSettingsService,
              private moment, private resizeService: ResizeService, private batchRequestsService: BatchRequestsService, private breadcrumbsService: BreadcrumbsService,
              private planningClusteringAreasRequestsService, private $scope: IScope, private $q: IQService, private bringozLoaderService: BringozLoaderService) {
    this.serviceAreasRef = this.$serviceArea();
    this.loadingState = this.planningProjectsService.getLoading;
    this.projectsProcessTrackingRef = this.$planningProjectsProcessTracking();
  }

  $onInit() {
    this.breadcrumbsService.off();
    this.excludeMode = true;
    this.selectedJobIds = [];
    this.selectedJobs = [];
    this.selectedResourceIds = [];

    this.selectedTab = 'Services';
    this.sortJobsSlaType = 'desc';

    this.projectRef = this.$planningProjects(this.project.id);

    if (!_.isEmpty(this.jobs)) {
      this.jobs = this._getSortedJobs(this.jobs);
      this.onJobsUpdate(this.jobs);
    }

    if (!_.isEmpty(this.resources)) {
      this.onResourcesUpdate(this.resources);
    }

    if (!this.serviceAreas) {
      this.serviceAreas = [];
    }

    if (!this.project.clusteringAreaIds) {
      this.project.clusteringAreaIds = [];
    }

    if (!this.viewSettings) {
      this.viewSettings = {
        settings: this._getDefaultViewSettings()
      };
    } else {
      const hasDefaultChanged = this._getHasDefaultViewSettingsChanged(this.viewSettings.settings);
      if (!!hasDefaultChanged) {
        this.viewSettings.settings = this._getDefaultViewSettings();
      }
    }

    this.getProjectDepots();

    this.setProjectData(this.project);
    this.bindProjectEventListener();
    this.bindProjectProcessEventListener();
  }

  $onChanges(onChangesObj: angular.IOnChangesObject) {
    if (onChangesObj.projectStatus && _.isEqual(this.projectStatus, 'RUNNING')) {
      this.planningDialogService.draftDispatchingLoader(this.project.id, this.project.selectedDraftId)
        .then(() => {
          if (_.isEqual(this.projectStatus, 'DISPATCHED')) {
            this.planningAlertsService.approveAndDispatchDraftSuccess();
            this.$state.go(this.planningConstants.states.completed, {draftId: this.project.selectedDraftId});
          }
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    }
  }

  $onDestroy() {
    this.projectsProcessTrackingRef.$destroyChannel();
    this.breadcrumbsService.on();

    // Safety net: if a create-draft loader is still up when this view is torn down (e.g. the
    // request never resolved before the user navigated away), close it before its parent DOM node
    // (#planning-project-view-container) is destroyed - otherwise $mdDialog never gets a chance to
    // clean up after itself and leaves document.body stuck with the "md-dialog-is-showing" class.
    this.planningDialogService.ProjectOptimizingLoader(false);
  }

  // ******************************
  //        Public methods
  // ******************************

  // Project
  onEditProjectDetails($event) {
    this.planningDialogService.updateProjectDetails(this.project, $event)
      .then((updatedProjectDetails) => {
        return this.planningProjectsService.updateProjectDetails(updatedProjectDetails)
      })
      .then(  (updatedProject) => {
        this.project.name = updatedProject.name;
      })
      .catch( ()=> {
        this.$log.info('Dialog Closed')
      })
  }

  onEditProjectSettings(event) {
    this._editProjectSettings(this.project, this.draftTemplate, event);
  }

  onClusteringAreasUpdated(clusteringAreas) {
    this.clusteringAreas = angular.copy(clusteringAreas || []);
  }

  onJobSelect(jobId) {
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  onSelectedJobsChange(jobIds) {
    this.selectedJobIds = jobIds;
    this.jobs = this._getSortedJobs(this.jobs);

    this.setSelectedJobs();
  }

  onSelectedResourcesChange(resourceIds) {
    this.selectedResourceIds = resourceIds;
    this.resources = this._getSortedResources(this.resources);
  }

  onLeftOverJobSelect(jobId) {
    this.$log.info(jobId);
    if (!_.includes(this.selectedJobIds, jobId)) {
      this.selectedJobIds = this.selectedJobIds.concat([jobId]);
    } else {
      this.selectedJobIds = _.filter(this.selectedJobIds, function (id) {
        return id !== jobId;
      })
    }
    this.jobs = this._getSortedJobs(this.jobs);
    this.setSelectedJobs();
  }

  onViewJob(jobId: string, $event) {
    const job = _.find(this.jobs, (j) => {
      return j.id === jobId;
    })
    if (job) {
      this.planningDialogService.viewJob(job, $event)
        .catch(() => {
          this.$log.info('Dialog Closed')
        })
    }
  }


  // ONLY FOR TESTING - SUPER OWNER
  onAddJob(event) {
    this.planningDialogService.addJob(event, this.project)
      .then((jobToCreate) => {
        return this.planningProjectsService.addJobs([jobToCreate], this.project);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddOrders(event) {
    this.planningDialogService.addOrders(event, this.project, this.projectTemplate)
      .then((payload) => {
        // this.PlanningDialogService.ProjectOptimizingLoader(true, event);
        return this.planningProjectsService.addOrders(payload, this.project.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddServices(event) {
    this.planningDialogService.addServices(event, this.project, this.projectTemplate)
      .then((payload) => {
        this.planningProjectsService.addServices(payload, this.project.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddAbortedServices(event) {
    this.planningDialogService.addAbortedServices(event, this.project)
      .then((payload) => {
        this.planningProjectsService.addAbortedServices(payload, this.project.id)
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // onAddSteps(event) {
  //   this.PlanningDialogService.addSteps(event, this.project)
  //     .then((payload) => {
  //       return this.planningProjectsService.addSteps(
  //         payload.from,
  //         payload.to,
  //         payload.statuses,
  //         payload.branchIds,
  //         payload.accountIds,
  //         payload.serviceAreaIds,
  //         payload.attempts,
  //         payload.tagNames,
  //         payload.schedulingRequired,
  //         this.project
  //       );
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onAddFulfillments(event) {
    this.planningDialogService.addSteps(event, this.project, this.projectTemplate)
      .then((filters) => {
        const FulfillmentExtFilter = {
          stepFilter: {
            from: this.moment(filters.from).valueOf(),
            to: this.moment(filters.to).valueOf(),
            accountIds: filters.accountIds,
            vehicleIds: filters.vehicleIds,
            schedulingRequired: filters.schedulingRequired,
            noFromLocation: filters.noFromLocation,
            noToLocation: filters.noToLocation,
            obligateTimeWindow: filters.obligateTimeWindow,
            isReturn: filters.isReturnDelivery,
            branchIds: filters.branchIds,
            serviceAreaIds: filters.serviceAreaIds,
            tags: filters.tags,
            excludedTags: filters.excludedTags,
            routed: filters.inRoute,
            programTypes: filters.programIds,
            approvalStatuses: filters.approvalStatuses,
            types: filters.serviceTypes,
            displayStatuses: filters.displayStatuses,
            depotIds: filters.depotIds,
            filterByCreatedAt: filters.filterByCreatedAt,
            agentIds: filters.agentIds,
            firstMile: filters.fulfillmentMileType === 'firstMile' ? true : undefined,
            middleMile: filters.fulfillmentMileType === 'middleMile' ? true : undefined,
            lastMile: filters.fulfillmentMileType === 'lastMile' ? true : undefined
          },
          fulfillmentFilter: {
            packageTypes: filters.packagesIds?.length ? filters.packagesIds : undefined
          }
        }
        this.planningProjectsService.addFulfillments(FulfillmentExtFilter, this.project.id);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed')
      })
  }

  onUploadJobs(event) {
    this.commonsDialogService.importFileMapping('Job', 'planning/projects/jobs')
      .then((filePreview) => {
        this.planningProjectsService.importJobsIntoProject(this.project.id, filePreview);
      })
  }

  //used at template
  // onEditJob(job, event) {
  //   this.planningDialogService.editJob(job, this.project, event)
  //     .then((editedJob) => {
  //       this.updateJob(editedJob, this.project);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  onDeleteJob(job) {
    this.onDeleteJobs([job.id])
  }

  onDeleteJobs(jobIds) {
    if (this.project.draftsIds?.length) {
      this.commonsDialogService.infoDialog('Can not apply action', 'Can not remove services as there are existing drafts. You may exclude the resource on the Draft level');
      return;
    }
    this.planningProjectsService.deleteJobs(jobIds, this.project)
      .then((deletedJobIds) => {
        this.onJobsDeleted(deletedJobIds);
      });
  }

  updateJobPriority(job, project) {
    this.planningProjectsService.updateJob(job, project)
      .then((updatedJob: any) => {
        const jobsCopy = angular.copy(this.jobs);
        const jobIndex = _.findIndex<any>(jobsCopy, (j) => {
          return j.id === updatedJob.id
        });

        jobsCopy.splice(jobIndex, 1, updatedJob);
        this.jobs = this._getSortedJobs(jobsCopy);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddResourcesClick(event) {
    const actions = this.planningConstants.resourceActions;

    this.commonsService.openActionPanel(actions, event)
      .then((reason: any) => {
        if (reason.key === 'ALLOCATIONS') {
          this.selectAllocationResources(event);
        }
        if (reason.key === 'VEHICLES') {
          this.selectVehicleResources(event);
        }
      })
      .catch((reason) => {
        this.$log.info('Action Panel Closed', reason);
      });
  }

  onAddResourcesByType(type, event) {
    if (type === 'Allocations') {
      this.selectAllocationResources(event);
    }
    if (type === 'Vehicles') {
      this.selectVehicleResources(event);
    }
  }

  selectAllocationResources(event) {
    const resources = angular.copy(this.resources);
    _.forEach(resources, (r) => {
      _.set(r, 'id', r.allocationId + '_' + r.startTime + '_' + r.endTime);
    })
    const currentResourceIds = _.map(resources, 'allocationId');
    this.planningDialogService.selectAllocationResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, {[SiteFiltersType.tags]: true}, true, event, this.draftTemplate)
      .then((payload) => {
        if (payload.selectedResources && payload.selectedResources.length) {
          this.addResourcesToProject(payload.selectedResources, payload.importAllocationResourcesServiceTemplate);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  selectVehicleResources(event) {
    const currentResourceIds = _.map(this.resources, 'vehicleId');
    this.planningDialogService.selectVehicleResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, event)
      .then((selectedResources) => {
        if (selectedResources && selectedResources.length) {
          this.addResourcesToProject(selectedResources);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  selectAgentsScheduleResources(event) {
    const currentResourceIds = _.map(this.resources, 'instanceResourceId');
    this.planningDialogService.selectAgentsScheduleResources(this.project.from, this.project.to,
      this.project.id, this.project.branchIds, currentResourceIds, {[SiteFiltersType.tags]: true}, event)
      .then((selectedResources) => {
        if (selectedResources && selectedResources.length) {
          this.addResourcesToProject(selectedResources);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onDeleteResources(ids) {
    if (this.project.draftsIds?.length) {
      this.commonsDialogService.infoDialog('Can not apply action', 'Can not remove resources as there are existing drafts. You may exclude the resource on the Draft level');
      return;
    }
    this.planningProjectsService.deleteResources(ids, this.project)
      .then((deletedResourceIds: any) => {
        this.resources = _.filter(this.resources, (r) => {
          return _.indexOf(deletedResourceIds, r.id) === -1
        });
      });
  }

  // // Depots
  // onSelectDepotsToProject(event) {
  //   const currentDepots = _.get(this.project, 'depots', []);
  //   this.PlanningDialogService.selectDepots(this.project.id, currentDepots, event)
  //     .then((selectedDepots) => {
  //       return this.planningProjectsService.addDepots(selectedDepots, this.project)
  //     })
  //     .then((depotsAdded) => {
  //       if (!this.depots) {
  //         this.depots = [];
  //       }
  //       this.depots = this.depots.concat(depotsAdded);
  //     })
  //     .catch(() => {
  //       this.$log.info('Dialog Closed')
  //     })
  // }

  // onDeleteDepotFromProject(depot) {
  //   this.planningProjectsService.deleteDepots([depot.id], this.project)
  //     .then((deletedDepotIds) => {
  //       this.depots = _.filter(this.depots, (d) => {
  //         return _.indexOf(deletedDepotIds, d.id) === -1
  //       });
  //     });
  // }

  // Drafts
  onCreateDraft(event) {

    if (!this.jobs || !this.jobs.length) {
      this.planningAlertsService.createDraftNoStopsInfo();
      return;
    }

    if (!this.resources || !this.resources.length) {
      this.planningAlertsService.createDraftNoResourcesInfo();
      return;
    }

    const excludeJobIds = _.chain(this.jobs)
      .filter((j) => {
        return !_.includes(this.selectedJobIds, j.id);
      })
      .map('id')
      .value();

    let jobsCopy = _.orderBy(this.jobs, [this.sortBy], [this.sortByType]);

    const selectedJobs = _.filter(jobsCopy, (j: any) => {
      return _.includes(this.selectedJobIds, j.id);
    })

    const excludeResourceIds = _.chain(this.resources)
      .filter((r) => {
        return !_.includes(this.selectedResourceIds, r.id);
      })
      .map('id')
      .value();

    const depots = this.depots || [];
    const projectCopy = angular.copy(this.project);
    if (this.project.draftTemplateId && this.project.useDraftTemplateSettings && this.draftTemplate?.settings) {
      projectCopy.settings = angular.copy(this.draftTemplate.settings);
    }
    this.isRedirecting = true;
    this.planningDialogService.createDraft(projectCopy, depots, selectedJobs, this.draftTemplate, event)
      .then((draftSettings) => {
        // ctrl.excludeMode = ctrl.selectedJobIds.length > ctrl.jobs.length/2;

        this.planningDialogService.ProjectOptimizingLoader(true);
        return this.planningDraftsService.createDraft(draftSettings.settings, draftSettings.draftName, excludeJobIds, excludeResourceIds, this.project.id, draftSettings.isOptimizedDraft, draftSettings.draftTemplateId, draftSettings.useDraftTemplateSettings, draftSettings.optimizationSteps)
          .then((createdDraft: any) => {
            this.planningDialogService.ProjectOptimizingLoader(false);
            this.project.selectedDraftId = createdDraft.id;
            // $state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: 'planning.project.scheme.draft'});
            this.$state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: false});
          })
          .catch((err) => {
            // The loader was already open for this attempt - make sure it's closed even though
            // creation failed, otherwise it's left showing with nothing left to hide it.
            this.planningDialogService.ProjectOptimizingLoader(false);
            this.planningAlertsService.createDraftInProjectError();
            this.isRedirecting = false;
          });
      })
      .catch((err) => {
        this.$log.info('Dialog Closed');
        this.isRedirecting = false;
      })
  }

  onCreateEmptyDraft(event) {

    if (!this.jobs || !this.jobs.length) {
      this.planningAlertsService.createDraftNoStopsInfo();
      return;
    }

    if (!this.resources || !this.resources.length) {
      this.planningAlertsService.createDraftNoResourcesInfo();
      return;
    }

    const excludeJobIds = _.chain(this.jobs)
      .filter((j) => {
        return !_.includes(this.selectedJobIds, j.id);
      })
      .map('id')
      .value();

    const excludeResourceIds = _.chain(this.resources)
      .filter((r) => {
        return !_.includes(this.selectedResourceIds, r.id);
      })
      .map('id')
      .value();

    this.planningDialogService.ProjectOptimizingLoader(true);
    this.isRedirecting = true;
    this.planningDraftsService.createEmptyDraft(this.project.settings, undefined, excludeJobIds, excludeResourceIds, this.project.id, false, undefined, undefined, angular.copy(this.project.optimizationSteps))
      .then((createdDraft: any) => {
        this.planningDialogService.ProjectOptimizingLoader(false);
        this.project.selectedDraftId = createdDraft.id;
        this.$state.go('^.draft', {draftId: createdDraft.id}, {notify: true, reload: false});
      })
      .catch(() => {
        this.planningDialogService.ProjectOptimizingLoader(false);
        this.planningAlertsService.createDraftInProjectError();
        this.isRedirecting = false;
      })
  }

  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  // ******************************
  //        Private methods
  // ******************************

  private bindProjectEventListener() {
    this.projectRef.$registerOnUpdateHandler(this, (updatedProject) => {
      if (_.isEqual(this.project.id, updatedProject.id) &&
        (updatedProject.updatedAt > this.project.updatedAt)) {
        this.setProjectData(updatedProject);
      }
    });
  }

  private bindProjectProcessEventListener() {
    this.projectsProcessTrackingRef.$subscribeToChannelEvents((createdProcesses, action) => {
      const projectProcess = _.find(createdProcesses, (process) => {
        return process.processId === this.project.id;
      })

      if (!this.isRedirecting && projectProcess?.processStatus === 'IN_PROGRESS') {
        this.planningDialogService.ProjectImportLoader(projectProcess)
          .then(() => {
            this._refreshProjectAfterImport();
            this.bindProjectProcessEventListener();
          })
      }
    });
  }

  private setProjectData(updatedProject) {
    const previousProjectStatus = this.project.status;
    this.project = updatedProject;

    // Project Statuses - SCHEME/IMPORT/RUNNING/COMPLETED/DISPATCHED
    this.$log.info('Project Status:', updatedProject.status);

    if (previousProjectStatus === 'IMPORT' && updatedProject.status === 'SCHEME') {
      // this.PlanningDialogService.ProjectOptimizingLoader(false);

      this.getProjectJobs();
      this.getProjectResources();
      this.getProjectDepots();
      this._loadClusteringAreasForMap();

      // Jobs Out Of Project Warning
      if (updatedProject.settings.considerTimeWindows) {

        const jobsOutOfProjectScope = this.getJobsOutOfProjectScope(updatedProject)

        if (jobsOutOfProjectScope.length) {
          // TODO connect to new flow
          // this.PlanningDialogService.jobsOutOfProjectScope(jobsOutOfProjectScope)
          //   .then((ignoreTimeWindows) => {
          //     if (ignoreTimeWindows) {
          //       const settingsToUpdate = angular.copy(this.project.settings);
          //       settingsToUpdate.considerTimeWindows = false;
          //       this.updateProjectSettings(settingsToUpdate)
          //     }
          //   })
        }

      }
    }

    if (_.isEqual(updatedProject.status, 'IMPORT')) {
      this.planningProjectProcessTrackingRequestsService.getProjectProcesses(this.project.id, 'IN_PROGRESS').then(processes => {
        if (processes.length) {
          this.planningDialogService.ProjectImportLoader(processes[processes.length - 1])
            .then(() => this._refreshProjectAfterImport());
        } else {
          this.planningProjectProcessTrackingRequestsService.getProjectProcesses(this.project.id).then(processes => {
            this.planningDialogService.ProjectImportLoader(processes[processes.length - 1])
              .then(() => this._refreshProjectAfterImport());
          })
        }
      }).catch((error) => {
        this.$log.error('Failed to get batch progress', error);
      })
    }

  }

  private _refreshProjectAfterImport() {
    this.bringozLoaderService.on();

    this.$q.all([
      this.getProjectJobs(),
      this.getProjectResources(),
      this.getProjectDepots()
    ]).finally(() => {
      this.bringozLoaderService.off();
    });

    this._loadClusteringAreasForMap();
  }

  private _loadClusteringAreasForMap() {
    const ownerId = this.project?.id;
    const areaIds = this.project?.clusteringAreaIds || [];
    const idsKey = _.sortBy(areaIds).join(',');

    if (this.loadedClusteringAreaIdsKey === idsKey) {
      return;
    }

    this.loadedClusteringAreaIdsKey = idsKey;

    if (!ownerId || !areaIds.length || this.project.snapshot) {
      this.clusteringAreas = [];
      return;
    }

    this.planningClusteringAreasRequestsService.getClusteringAreasForMap(ownerId, areaIds)
      .then((areas) => {
        const currentKey = _.sortBy(this.project?.clusteringAreaIds || []).join(',');
        if (currentKey !== idsKey) {
          return;
        }

        this.clusteringAreas = areas;
      })
      .catch((error) => {
        this.$log.error('Failed to load clustering areas for map', error);
        this.clusteringAreas = [];
      });
  }

  private updateJob(job, project) {
    this.planningProjectsService.updateJob(job, project)
      .then((updatedJob: any) => {
        const jobsCopy = angular.copy(this.jobs);
        const jobIndex = _.findIndex<any>(jobsCopy, (j) => {
          return j.id === updatedJob.id
        });

        jobsCopy.splice(jobIndex, 1, updatedJob);
        this.jobs = this._getSortedJobs(jobsCopy);
        // ctrl.projectJobsByStatus = _setJobsByStatus(jobsCopy);

        if (!project.selectedDraftId) {
          this.stops = this.getStopsFromJobs(this.jobs);
        }
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private addResourcesToProject(resources, importAllocationResourcesServiceTemplate?: boolean) {
    this.planningProjectsService.addResources(resources, this.project, importAllocationResourcesServiceTemplate)
      .then((resourcesAdded) => {
        if (!this.resources) {
          this.resources = [];
        }
        this.resources = this.resources.concat(resourcesAdded);
        this.onResourcesUpdate(this.resources);
      })
  }

  private onJobsDeleted(deletedJobIds) {
    const filteredJobs = _.filter(this.jobs, (j) => {
      return !_.includes(deletedJobIds, j.id);
    });
    this.jobs = this._getSortedJobs(filteredJobs);
    this.selectedJobIds = [];
    this.selectedJobs = [];

    if (!this.project.selectedDraftId) {
      this.stops = this.getStopsFromJobs(this.jobs);
    }
  }


  private getStopsFromJobs(jobs) {
    const stops = [];

    _.forEach(jobs, (j) => {
      _.forEach(j.stops, (s) => {
        stops.push(s);
      })
    });
    return stops;
  }


  private _editProjectSettings(project, draftTemplate, event) {
    const depots = this.depots || [];
    const selectedJobs = this.selectedJobs || [];

    this.planningDialogService.editProjectSettings(project, draftTemplate, depots, selectedJobs, event, (clusteringAreas) => {
      this.onClusteringAreasUpdated(clusteringAreas);
    })
      .then((payload: { project: any }) => {
        return this.planningProjectsService.updateProjectDetails(payload.project);
      })
      .then((updatedProject: any) => {
        this.project = updatedProject;
        this.loadedClusteringAreaIdsKey = undefined;
        this._loadClusteringAreasForMap();
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private getJobsOutOfProjectScope(project) {
    if (!this.jobs) {
      return [];
    }
    return _.filter(this.jobs, (j) => {
      const stopsRef = _.get(j, 'stops', []),
        jobNotBefore = _.get(stopsRef, '[0].notBefore'),
        lastStopRef = stopsRef[stopsRef.length - 1],
        jobNotAfter = _.get(lastStopRef, 'notBefore');

      if (jobNotBefore && jobNotAfter) {
        return jobNotBefore < project.from || jobNotAfter > project.to;
      } else {
        return false;
      }
    })
  }


  getProjectJobs() {
    return this.planningProjectsService.getJobs(this.project.id)
      .then((jobs) => {
        this.jobs = this._getSortedJobs(jobs);
        this.onJobsUpdate(jobs);
      })
  }

  getProjectResources() {
    return this.planningProjectsService.getResources(this.project.id)
      .then((resources) => {
        this.resources = resources;
        this.onResourcesUpdate(resources);
      })
  }

  getProjectDepots() {
    if (this.project.snapshot) {
      return;
    }

    return this.planningProjectsService.getDepots(this.project.id)
      .then((depots) => {
        this.depots = depots;
      })
  }

  onViewSettingsChange(settings) {
    // this.viewSettings.settings = settings;

    if (this.viewSettings?.id) {
      const viewTableSettingsCopy = {...this.viewSettings, settings: settings};
      viewTableSettingsCopy.holderType = ViewSettingsHolderType.User;

      this.viewSettingsService.updateByUser(this.viewSettings.id, viewTableSettingsCopy)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable
        })

    } else {
      const viewTableSettings = {
        pageName: 'planning.draft',
        holderType: ViewSettingsHolderType.User,
        settingsType: ViewSettingsType.ViewTable,
        settings: settings
      }
      this.viewSettingsService.createByUser(viewTableSettings)
        .then((viewSettingsTable: ViewSettingsModel) => {
          this.viewSettings = viewSettingsTable
        })
    }
  }

  resizeScreen() {
    this.resizeService.resize();
  }

  onJobsSettingsChange(settings) {
    this.viewSettings.settings.jobs = settings;
    this.onViewSettingsChange(this.viewSettings.settings);
  }

  onResourcesSettingsChange(settings) {
    this.viewSettings.settings.resources = settings;
    this.onViewSettingsChange(this.viewSettings.settings);
  }

  onSelectDraft(draftId) {
    this.$state.go('planning.project.draft', {project: this.project.id, draftId: draftId}, {
      notify: true,
      reload: false
    });
  }

  onBackToProjects() {
    this.$state.go(this.planningConstants.states.projectsCalendar);
  }

  onSortByChange(sortBy, sortByType) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.jobs = this._getSortedJobs(this.jobs);
  }


  private onJobsUpdate(jobs) {
    this.stops = this.getStopsFromJobs(jobs);
    this.selectedJobIds = _.map(jobs, 'id');
    this.setServiceAreasByJobs(jobs);
    this.setSelectedJobs();
  }

  private onResourcesUpdate(resources) {
    this.selectedResourceIds = _.map(resources, 'id');
    this.resources = this._getSortedResources(this.resources);
  }

  private setServiceAreasByJobs(jobs) {
    if (this.project.snapshot) {
      return;
    }

    const areaIds = _.chain(jobs)
      .map('areaIds')
      .flatten()
      .uniq()
      .value();

    this.serviceAreasRef.$asyncValues(areaIds)
      .then((serviceAreas) => {
        this.serviceAreas = _.uniqBy(this.serviceAreas.concat(serviceAreas), 'areaId');
      })
  }

  private setSelectedJobs() {
    this.selectedJobs = _.chain(this.selectedJobIds)
      .map((id) => {
        return _.find(this.jobs, (j) => {
          return j.id === id;
        })
      })
      .compact()
      .value();
  }

  private _getSortedJobs(jobs) {

    _.forEach(jobs, (j) => {
      j.spotsAmount = this.$filter('orderSpots')(j.packages);
      j.packagesAmount = this.$filter('servicePackagesCount')(j.packages);
      j.packagesWeight = _.reduce(j.packages, (sum, i) => {
        return sum + _.get(i, 'weight', 0);
      }, 0);
      j.packagesVolume = _.reduce(j.packages, (sum, i) => {
        return sum + _.get(i, 'volume', 0);
      }, 0);
      j.packagesPallets = _.reduce(j.packages, (sum, i) => {
        return sum + _.get(i, 'pallets', 0);
      }, 0);
      j.packagesValue = _.reduce(j.packages, (sum, i) => {
        return sum + _.get(i, 'value', 0);
      }, 0);

      j.city = j.jobType === 'Delivery' ? j.city = j.stops[1].address.city : j.stops[0].address.city;
    })

    let jobsCopy = _.orderBy(jobs, [this.sortBy], [this.sortByType]);

    // all the selected jobs will be on top
    const selectedJobs = _.filter(jobsCopy, (j: any) => {
      return _.includes(this.selectedJobIds, j.id);
    })
    const unselectedJobs = _.filter(jobsCopy, (j: any) => {
      return !_.includes(this.selectedJobIds, j.id);
    })
    return _.concat(selectedJobs, unselectedJobs);
  }

  private _getSortedResources(resources) {

    // all the selected resources will be on top
    const selected = _.filter(resources, (r) => {
      return _.includes(this.selectedResourceIds, r.id);
    })
    const unselected = _.filter(resources, (r) => {
      return !_.includes(this.selectedResourceIds, r.id);
    })
    return _.concat(selected, unselected);
  }

  private _getHasDefaultViewSettingsChanged(viewSettings: PlanningViewSettingsModel): boolean {
    const defaultSettings = this._getDefaultViewSettings();
    return _.size(defaultSettings.jobs.columns) !== _.size(viewSettings?.jobs.columns) ||
      _.size(defaultSettings.jobs.load) !== _.size(viewSettings?.jobs.load) ||
      _.size(defaultSettings.routes.columns) !== _.size(viewSettings?.routes.columns) ||
      _.size(defaultSettings.routes.load) !== _.size(viewSettings?.routes.load) ||
      _.size(defaultSettings.routes.capacity) !== _.size(viewSettings?.routes.capacity) ||
      _.size(defaultSettings.route.columns) !== _.size(viewSettings?.route.columns) ||
      _.size(defaultSettings.route.load) !== _.size(viewSettings?.route.load) ||
      _.size(defaultSettings.route.capacity) !== _.size(viewSettings?.route.capacity) ||
      _.size(defaultSettings.resources.columns) !== _.size(viewSettings?.resources.columns) ||
      _.size(defaultSettings.resources.load) !== _.size(viewSettings?.resources.load) ||
      _.size(defaultSettings.resources.capacity) !== _.size(viewSettings?.resources.capacity) ||
      _.size(defaultSettings.draft.columns) !== _.size(viewSettings?.draft.columns);

  }

  private _getDefaultViewSettings(): PlanningViewSettingsModel {
    return this.planningConstants.defaultViewSettings;
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningProjectViewNew', {
    bindings: {
      project: '<',
      projectStatus: '<',
      jobs: '<',
      resources: '<',
      depots: '<?',
      viewSettings: '<?',
      draftTemplate: '<?',
      projectTemplate: '<?',
      defaultDraftViewSettings: '<?'
    },
    template: require('./planning-project-view-new.html').default,
    controller: PlanningProjectViewNewComponent
  });
